import { Flex } from '@chakra-ui/react';
import { addYears, startOfDay } from 'date-fns';
import { useDispatch } from 'react-redux';

import { past3Months } from 'constants/ProjectConstants';
import { localStorageKeys } from 'constants/localStorageKeys';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';

import {
  setSelectedDateRangeEngagementIntent,
  useSelectEngagementSelectedIntent,
} from '../slice/EngagementIntentSlice';
import { EngagementSplitByDropdown } from './EngagementSplitByDropdown';
import { EngagementSurveyDropdown } from './EngagementSurveyDropdown';
import { EngagementViewByDropdown } from './EngagementViewByDropdown';

export const setTimeBoundsToLS = (timeBounds) => {
  try {
    window.localStorage.setItem(localStorageKeys.teamPageGoalsTimeBounds, JSON.stringify(timeBounds));
  } catch (e) {
    console.error('Error in saving to LS: ', e);
  }
};

const EngagementMetaFilters = () => {
  const dispatch = useDispatch();
  const { showTimelineDropdown, showSplitByDropdown, showSurveyDropdown, showViewByDropdown } =
    useSelectEngagementSelectedIntent() ?? {};

  const updateDateRange = (dateRange) => {
    dispatch(setSelectedDateRangeEngagementIntent(dateRange));
  };

  return (
    <Flex gap="12px">
      {showSurveyDropdown && <EngagementSurveyDropdown />}
      {showSplitByDropdown && <EngagementSplitByDropdown />}
      {showViewByDropdown && <EngagementViewByDropdown />}
      {showTimelineDropdown && (
        <DateRangeDropdown
          // @ts-expect-error idk :(
          onSelect={updateDateRange}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={past3Months}
          showPredefinedRanges
          variant="chip"
        />
      )}
    </Flex>
  );
};

export { EngagementMetaFilters };
